import { Grid } from '@mui/material'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import AutocompleteTecnico from '../atoms/AutocompleteTecnico'

export default function FormTreinamento() {
    return (
        <Grid container spacing={1} columnSpacing={2} mb={1}>
            <Grid item xs={12} sm={5}>
                <FormField
                    name="data"
                    label="Data"
                    type="datetime-local"
                    required
                    InputLabelProps={{ shrink: true }}
                />
            </Grid>
            <Grid item xs={12} sm={7}>
                <FormField
                    name="quemRecebeu"
                    label="Quem recebeu"
                    required
                    max={50}
                    autoComplete="off"
                />
            </Grid>
            <Grid item xs={12}>
                <AutocompleteTecnico />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="observacao"
                    label="Observação"
                    multiline
                    minRows={3}
                    max={250}
                />
            </Grid>
            <Grid item xs={12}>
                <FormFieldCheckbox name="cobranca" label="Cobrança" />
            </Grid>
        </Grid>
    )
}
